/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Conservatoire Specialisms View Model
    /**************************************/
    function ConservatoireSpecialismsViewModel() {

        var self = this;

        /***  PROPERTIES ***/
        this.DataList = ko.observableArray();
        /***  PROPERTIES ***/

        /***  LIST DATA PROPERTIES ***/
        this.Specialisms = ko.observableArray();
        this.SpecialismCategories = ko.observableArray();
        this.StaffList = ko.observableArray();
        this.SpecialismCategoryMatrix = ko.observableArray();
        this.SpecialismStaffMatrix = ko.observableArray();
        this.sectionIncluded = ko.observable(false);
        /***  LIST DATA PROPERTIES ***/

        /***  SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable("ConservatoireSpecialismsContainer");
        this.Touched = ko.observable(false);
        this.IsRequired = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);
        /***  SECTION PROPERTIES ***/

        this.WorkingItem = ko.observable(new sm.portal.vm.ConservatoireSpecialismDataItem({
            Specialisms: this.Specialisms,
            SpecialismCategories: this.SpecialismCategories,
            StaffList: this.StaffList,
            SpecialismCategoryMatrix: this.SpecialismCategoryMatrix,
            SpecialismStaffMatrix: this.SpecialismStaffMatrix
        }));
        this.OriginalItem = ko.observable(new sm.portal.vm.ConservatoireSpecialismDataItem({
            Specialisms: this.Specialisms,
            SpecialismCategories: this.SpecialismCategories,
            StaffList: this.StaffList,
            SpecialismCategoryMatrix: this.SpecialismCategoryMatrix,
            SpecialismStaffMatrix: this.SpecialismStaffMatrix
        }));

        this.SaveWorkingChanges = function () {

            var workingItem = new sm.portal.vm.ConservatoireSpecialismDataItem({
                SpecialismID: self.WorkingItem().SpecialismID(),
                Specialism: self.WorkingItem().Specialism(),
                SpecialismCategoryID: self.WorkingItem().SpecialismCategoryID(),
                SpecialismCategory: self.WorkingItem().SpecialismCategory(),
                StaffID: self.WorkingItem().StaffID(),
                Staff: self.WorkingItem().Staff(),
                ReasonForStaffChange: self.WorkingItem().ReasonForStaffChange(),
                SpecialismCategoryMatrix: this.SpecialismCategoryMatrix,
                SpecialismStaffMatrix: this.SpecialismStaffMatrix,
                InEditMode: self.WorkingItem().InEditMode(),
                SectionRequired: self.IsRequired(),
                Specialisms: this.Specialisms,
                SpecialismCategories: this.SpecialismCategories,
                StaffList: this.StaffList
            });

            if (workingItem.SpecialismID()) {
                workingItem.Specialism(self.GetSpecialismNameById(workingItem.SpecialismID()).name);
            }

            if (workingItem.SpecialismCategoryID()) {
                workingItem.SpecialismCategory(self.GetSpecialismCategoryNameById(workingItem.SpecialismCategoryID()).name);
            }

            if (workingItem.StaffID()) {
                workingItem.Staff(self.GetStaffNameById(workingItem.StaffID()).name);
            }

            self.WorkingItem(new sm.portal.vm.ConservatoireSpecialismDataItem({
                Specialisms: this.Specialisms,
                SpecialismCategories: this.SpecialismCategories,
                StaffList: this.StaffList,
                SpecialismCategoryMatrix: this.SpecialismCategoryMatrix,
                SpecialismStaffMatrix: this.SpecialismStaffMatrix
            }));

            if (workingItem.IsVMValid()) {

                if (!workingItem.InEditMode()) {
                    // This is an Add...
                    self.DataList.push(workingItem);
                } else {
                    // NOTE: Edits automatically bind back to the list (knockout is cool, huh?)
                    workingItem.InEditMode(false);
                    self.OriginalItem().SpecialismID(workingItem.SpecialismID());
                    self.OriginalItem().Specialism(workingItem.Specialism());
                    self.OriginalItem().SpecialismCategoryID(workingItem.SpecialismCategoryID());
                    self.OriginalItem().SpecialismCategory(workingItem.SpecialismCategory());
                    self.OriginalItem().StaffID(workingItem.StaffID());
                    self.OriginalItem().Staff(workingItem.Staff());
                    self.OriginalItem().ReasonForStaffChange(workingItem.ReasonForStaffChange());
                    self.OriginalItem().InEditMode(workingItem.InEditMode());
                    self.OriginalItem().SpecialismCategoryMatrix(workingItem.SpecialismCategoryMatrix());
                    self.OriginalItem().SpecialismStaffMatrix(workingItem.SpecialismStaffMatrix());
                }

                sm.portal.ui.comboBox();

                // hide the data entry view
                jQuery('.dataEntryView').hide();

                // show the display view with one item
                jQuery('.dataDisplayView').show();
                jQuery('.dataDisplayView ul.detailedList li').not('.noneAdded').show();
            }
        };

        this.GetSpecialismNameById = function (id) {

            for (var i = 0; i < self.Specialisms().length; i++) {
                if (self.Specialisms()[i].Value() === id) {
                    return self.Specialisms()[i].Text();
                }
            }
            return "";
        }

        this.GetSpecialismCategoryNameById = function (id) {

            for (var i = 0; i < self.SpecialismCategories().length; i++) {
                if (self.SpecialismCategories()[i].Value() === id) {
                    return self.SpecialismCategories()[i].Text();
                }
            }
            return "";
        }

        this.GetStaffNameById = function (id) {

            for (var i = 0; i < self.StaffList().length; i++) {
                if (self.StaffList()[i].Value() === id) {
                    return self.StaffList()[i].Text();
                }
            }
            return "";
        }

        /** ADD/EDIT LIST METHODS **/
        this.CancelWorkingChanges = function () {
            self.WorkingItem(new sm.portal.vm.ConservatoireSpecialismDataItem({
                Specialisms: this.Specialisms,
                SpecialismCategories: this.SpecialismCategories,
                StaffList: this.StaffList,
                SpecialismCategoryMatrix: this.SpecialismCategoryMatrix,
                SpecialismStaffMatrix: this.SpecialismStaffMatrix
            }));

            //hide the display view
            jQuery('.dataEntryView').hide();

            // show the entry view
            jQuery('.dataDisplayView').show();
        };
        this.EditItem = function (data, event) {
            self.OriginalItem(data);

            self.WorkingItem(
                new sm.portal.vm.ConservatoireSpecialismDataItem(
                    JSON.parse(ko.toJSON(data))
                )
            );
            self.WorkingItem().InEditMode(true);

            jQuery('.dataDisplayView').hide();
            jQuery('.dataEntryView').show();
        };
        this.AddItem = function (data, event) {
            self.WorkingItem(
                new sm.portal.vm.ConservatoireSpecialismDataItem(
                    JSON.parse(ko.toJSON(data))
                )
            );
        };
        this.RemoveItem = function (data, event) {
            self.DataList.remove(function (item) {
                return item.SpecialismID == data.SpecialismID &&
                    item.SpecialismCategoryID == data.SpecialismCategoryID &&
                    item.StaffID == data.StaffID;
            });
        };
        /** ADD/EDIT LIST METHODS **/

        /***  COMPUTED PROPERTIES ***/
        this.AnythingPopulated = ko.computed(function () {
            if (this.DataList().length > 0) {
                for (var i = 0; i < this.DataList().length; i++) {
                    var dataItem = this.DataList()[i];
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.SpecialismID())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.Specialism())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.SpecialismCategoryID())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.SpecialismCategory())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.StaffID())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.Staff())) return true;
                }
            }
            return false;
        }, this);
        this.Completed = ko.computed(function () {
            if (this.IsRequired()) {
                return this.AnythingPopulated() && this.Touched();
            } else {
                return this.Touched();
            }
        }, this);
        /***  COMPUTED PROPERTIES ***/

        /*** SECTION METHODS ***/
        function loadSpecialismInfoListItemModel(source, target) {
            for (var i = 0; i < source.length; i++) {
                target.push(new SpecialismInfoListItemViewModel({
                    PrimaryID: source[i].PrimaryID,
                    PrimaryText: source[i].PrimaryText,
                    SpecialismIDs: source[i].SpecialismIDs
                }));
            }
            return target;
        };

        this.LoadModel = function (container) {
            try {
                // update application section configurations
                if (container && container.Payload && container.Payload.Config) {
                    viewModel.SetSectionsConfigData("ConservatoireSpecialisms", container.Payload.Config);
                }
                this.Specialisms = smapi.access.loadListItemModels(container.Payload.ListData.SpecialismOptions, this.Specialisms);
                this.SpecialismCategories = smapi.access.loadListItemModels(container.Payload.ListData.SpecialismCategoryOptions, this.SpecialismCategories);
                this.StaffList = smapi.access.loadListItemModels(container.Payload.ListData.StaffOptions, this.StaffList);
                this.SpecialismCategoryMatrix = loadSpecialismInfoListItemModel(container.Payload.ListData.SpecialismChangeMatrix.SpecialismCategoryLookup, this.SpecialismCategoryMatrix);
                this.SpecialismStaffMatrix = loadSpecialismInfoListItemModel(container.Payload.ListData.SpecialismChangeMatrix.SpecialismStaffLookup, this.SpecialismStaffMatrix);

                if (container.Payload.AdmissionsSpecialisms != null) {

                    for (var i = 0; i < container.Payload.AdmissionsSpecialisms.length; i++) {

                        var conservatoireSpecialism = container.Payload.AdmissionsSpecialisms[i];
                        var newDataItem = new sm.portal.vm.ConservatoireSpecialismDataItem({
                            SpecialismID: conservatoireSpecialism.SpecialismID,
                            Specialism: conservatoireSpecialism.Specialism,
                            SpecialismCategoryID: conservatoireSpecialism.SpecialismCategoryID,
                            SpecialismCategory: conservatoireSpecialism.SpecialismCategory,
                            StaffID: conservatoireSpecialism.StaffID,
                            Staff: conservatoireSpecialism.Staff,
                            ReasonForStaffChange: conservatoireSpecialism.ReasonForStaffChange,
                            Specialisms: this.Specialisms,
                            SpecialismCategories: this.SpecialismCategories,
                            StaffList: this.StaffList,
                            SpecialismCategoryMatrix: this.SpecialismCategoryMatrix,
                            SpecialismStaffMatrix: this.SpecialismStaffMatrix
                        });

                        this.DataList.push(newDataItem);
                    }
                }

                this.DataLoading(false);
                this.DataLoaded(true);
                if (smapi.constant.applicationDebugFlag) {
                    console.log('[ConservatoireSpecialismsVM] Data Loaded');
                }
            }
            catch(err) {

            }
        };
        this.GetModelData = function (blockui, applicationMID, personMID, callback) {

            if (!this.DataLoaded() && !this.DataLoading()) {

                this.DataLoading(true);
                if (blockui) { jQuery.blockUI(); }
                var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName=conservatoirespecialisms&attemptmid={0}', applicationMID);

                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        sm.portal.page.application.modelDataResponseHandler(self, data, applicationMID, personMID);
                        callback && callback(data);
                    },
                    error: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        callback && callback();
                    }
                });
            } else {
                callback && callback();
            }
        };
        this.CheckInclusion = function (applicationMID, personMID) {
            if(self.sectionIncluded()) return;
            
            var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/CheckApplicationSectionInclusion?sectionName=conservatoirespecialisms&attemptmid={0}', applicationMID);

            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    self.sectionIncluded(true);
                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    if (data.Status == 'success') {
                        var result = container.Payload.InclusionResult;
                        var sectionsToAdd = Array();
                        var sectionsToRemove = Array();

                        console.log('Inclusion Result for Conservatoire Specialisms: ' + result);
                        switch (result) {
                            case "Included":
                                sectionsToAdd.push({ section: 'ConservatoireSpecialisms', required: false });
                                break;
                            case "Required":
                                sectionsToAdd.push({ section: 'ConservatoireSpecialisms', required: true });
                                break;
                            case "Exclude":
                                sectionsToRemove.push('ConservatoireSpecialisms');
                                break;
                        }
                        console.log('Calling Maintain Sections');
                        viewModel.MaintainSections(sectionsToAdd, sectionsToRemove);
                    }
                },
                error: function (jqXHR, exception) {
                    sm.portal.page.application.modelErrorHandler(self, jqXHR);
                }
            });
        };
        this.BlockContainer = function () {
            jQuery("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function () {
            jQuery("#" + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };
        this.ProcessOnServer = function () {
            return true;
        };
        this.ExtractATO = function () {

            var atoList = Array();

            for (var i = 0; i < self.DataList().length; i++) {
                var dataListItem = self.DataList()[i];
                var ato = dataListItem.ExtractATO();
                atoList.push(ko.toJS(ato));
            }

            return atoList;
        };
        /*** SECTION METHODS ***/

        return self;
    };

    function ConservatoireSpecialismDataItem(options) {
        var defaults = {
            SpecialismID: '',
            SpecialismCategoryID: '',
            StaffID: '',
            ReasonForStaffChange: '',
            InEditMode: false,
            ID: -1,
            GID: null,
            Specialisms: null,
            SpecialismCategories: null,
            StaffList: null,
            SpecialismCategoryMatrix: null,
            SpecialismStaffMatrix: null
        };
        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        self.SpecialismID = ko.validatedObservable(settings.SpecialismID);
        self.Specialism = ko.validatedObservable(settings.Specialism);
        self.SpecialismCategoryID = ko.validatedObservable(settings.SpecialismCategoryID);
        self.SpecialismCategory = ko.validatedObservable(settings.SpecialismCategory);
        self.StaffID = ko.validatedObservable(settings.StaffID);
        self.Staff = ko.validatedObservable(settings.Staff);
        self.ReasonForStaffChange = ko.validatedObservable(settings.ReasonForStaffChange);
        self.GID = ko.validatedObservable(settings.GID);
        self.ID = ko.validatedObservable(settings.ID);
        self.InEditMode = ko.observable(settings.InEditMode);

        if (settings.Specialisms == undefined || settings.Specialisms == null) {
            self.Specialisms = ko.observableArray();
        } else {
            self.Specialisms = settings.Specialisms;
        }

        if (settings.SpecialismCategories == undefined || settings.SpecialismCategories == null) {
            self.SpecialismCategories = ko.observableArray();
        } else {
            self.SpecialismCategories = settings.SpecialismCategories;
        }

        if (settings.StaffList == undefined || settings.StaffList == null) {
            self.StaffList = ko.observableArray();
        } else {
            self.StaffList = settings.StaffList;
        }

        if (settings.SpecialismCategoryMatrix == undefined || settings.SpecialismCategoryMatrix == null) {
            self.SpecialismCategoryMatrix = ko.observableArray();
        } else {
            self.SpecialismCategoryMatrix = settings.SpecialismCategoryMatrix;
        }

        if (settings.SpecialismStaffMatrix == undefined || settings.SpecialismStaffMatrix == null) {
            self.SpecialismStaffMatrix = ko.observableArray();
        } else {
            self.SpecialismStaffMatrix = settings.SpecialismStaffMatrix;
        }

        /*** PROPERTIES ***/
        self.showReasonForStaffChange = ko.observable(false);
        self.editSpecialismFields = ko.observable(true);
        /*** PROPERTIES ***/

        /*** SUBSCRIBED PROPERTIES ***/

        this.SpecialismID.subscribe(function () {
            self.showReasonForStaffChange(settings.ReasonForStaffChange.length > 0);
            self.editSpecialismFields(settings.ReasonForStaffChange.length === 0);
        });

        /*** SUBSCRIBED PROPERTIES ***/

        self.ExtractATO = function () {

            return new smapi.admissions.AdmissionsSpecialismModel({
                SpecialismID: self.SpecialismID(),
                SpecialismCategoryID: self.SpecialismCategoryID(),
                StaffID: self.StaffID(),
                ReasonForStaffChange: self.ReasonForStaffChange(),
                ID: self.ID(),
                GID: self.GID()
            });
        }

        /*** FILTER FUNCTION ***/
        this.Filter = function (type, specialismID) {

            var sourceMatrix;
            var resultList = Array();

            switch (type) {
                case "SpecialismCategory":
                    sourceMatrix = self.SpecialismCategoryMatrix;
                    break;
                case "SpecialismStaff":
                    sourceMatrix = self.SpecialismStaffMatrix;
                    break;
            }   // End switch

            for (var i = 0; i < sourceMatrix.length; i++) {

                var currentItem = sourceMatrix[i];

                // Construct the Match Checkers
                var specialismMatch = sm.portal.utility.isNullOrEmpty(specialismID) ? '' : '|' + specialismID + '|';

                // Make the checks
                var isMatch = true;

                // Specialism 
                if (!sm.portal.utility.isNullOrEmpty(specialismMatch) && currentItem.SpecialismIDs.indexOf(specialismMatch) < 0) {
                    isMatch = false;
                }

                // Final check for NO FILTER VALUES WHATSOEVER
                if (sm.portal.utility.isNullOrEmpty(specialismMatch)) {
                    isMatch = false;
                }

                if (isMatch) {
                    var newItem = new smapi.access.ListItemModel({ Text: currentItem.PrimaryText, Value: currentItem.PrimaryID, ID: currentItem.PrimaryID });
                    resultList.push(newItem);
                }
            }

            return resultList;
        }
        /*** FILTER FUNCTION ***/

        /*** COMPUTED LIST PROPERTIES ***/
        self.AvailableSpecialismCategories = ko.computed(function () {
            return self.Filter("SpecialismCategory", this.SpecialismID());
        }, this);
        self.AvailableStaff = ko.computed(function () {
            return self.Filter("SpecialismStaff", this.SpecialismID());
        }, this);
        /*** COMPUTED LIST PROPERTIES ***/

        /*** VALIDATION METHODS ***/
        self.SpecialismID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        self.SpecialismCategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        self.StaffID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        self.ReasonForStaffChange.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });

 
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            var isCompleted = this.IsVMValid();
            return isCompleted;
        }, this);
        /*** VALIDATION METHODS ***/

        return self;
    };

    function SpecialismInfoListItemViewModel(options) {

        var defaults = {
            PrimaryID: 0,
            PrimaryText: '',
            SpecialismIDs: ''
        };
        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        this.PrimaryID = ko.observable(settings.PrimaryID);
        this.PrimaryText = ko.observable(settings.PrimaryText);
        this.SpecialismIDs = ko.observable(settings.SpecialismIDs);

        return self;
    }

    jQuery.extend(true, sm.portal.vm, {
        ConservatoireSpecialismsViewModel: ConservatoireSpecialismsViewModel,
        ConservatoireSpecialismDataItem: ConservatoireSpecialismDataItem,
        SpecialismInfoListItemViewModel: SpecialismInfoListItemViewModel
    });

})(jQuery);